export { SloganPrimary } from './SloganPrimary';
